(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.directive('sharedAgendaTable', [SharedAgendaTableFn]);

    /* shared agenda table directive */

    function SharedAgendaTableFn() {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: '/app/settings/agendasettings/modules/sharedagendas/templates/shared-agenda-table.template.html',
            controller: 'AgendaSettingsSharedAgendaTableController',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                sharedAgendaDto: '='
            }
        };
        return directive;

    }
})();